'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Circle = () => (React__default.default.createElement("svg", { viewBox: "0 0 16 16", width: "100%", height: "100%", stroke: "currentColor" },
    React__default.default.createElement("circle", { cx: "8", cy: "8", r: "7", fill: "none", strokeWidth: "2", pathLength: "100" })));

module.exports = Circle;
//# sourceMappingURL=circle.js.map
